import { useApi } from '@hooks/useApi';
import { StaffUser } from '@root/globalTypes';
import { useMutation } from '@tanstack/react-query';

type RequestResetPasswordParams = {
  id: string;
  callback: () => void;
};

export function useResetPassword({ id, callback }: RequestResetPasswordParams) {
  const { query } = useApi();
  const { mutate, isPending } = useMutation({
    mutationFn: (): Promise<StaffUser> => {
      return query({
        path: `v1/staff/users/${id}/password`,
        opt: {
          method: 'POST',
        },
      });
    },
    onSettled: (data) => {
      if (!data) return;
      callback();
    },
  });

  return {
    mutate,
    isPending,
  };
}
